module.exports = __webpack_public_path__ + "img/d_sv2.b5ce206.png";